import { render, staticRenderFns } from "./modalCalificaciones.vue?vue&type=template&id=72090392&"
import script from "./modalCalificaciones.vue?vue&type=script&lang=js&"
export * from "./modalCalificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports